import { z } from "zod";

export const symptomsSchema = z.object({
  symptoms: z.string().nonempty("Os sintomas são obrigatórios"),
});

export type TSymptomsForm = z.infer<typeof symptomsSchema>;
